import clsx from 'clsx';
import React from 'react';
import { Link } from 'react-router-dom';

import { Heading } from '@/components/typography/heading';

export default function NotFound() {
  return (
    <div className={ clsx( 'page', 'center_xy' ) }>
      <Heading>Uh oh...</Heading>
      <p>You accidentally stumbled here instead of trying to be somewhere you shouldn&apos;t be right?</p>
      <Link to='/'>Return Home</Link>
    </div>
  );
}